import { Component, EventEmitter, Input, Optional, Output } from "@angular/core";
import { NbComponentStatus, NbDialogRef } from "@nebular/theme";

@Component({
    selector: "kno2-alert",
    templateUrl: "./alert.component.html",
    styleUrls: ["./alert.component.scss"],
    standalone: false
})
export class AlertComponent {
    @Input() public closable = true;
    @Input() public isDialog?: boolean;
    public title: Partial<Record<NbComponentStatus, string>> = {
        success: "Sucess!",
        info: "Notice!",
        warning: "Warning!",
        danger: "Oh no!"
    };
    @Input() public status: NbComponentStatus;
    @Input() public message?: string;
    @Input() public items?: Array<string>;
    /**
     * Emitted when the alert is not a dialog
     */
    @Output() public closeClick = new EventEmitter();

    constructor(@Optional() private dialogRef: NbDialogRef<AlertComponent>) {
        if (this.isDialog === undefined) this.isDialog = !!this.dialogRef;
    }

    public get alertClasses(): Array<Array<string>> {
        const itemsExist = !!this.items?.length;
        return [`border-${this.status}`, ...(itemsExist ? ["pb-3", "mb-2", "border-bottom"] : ["pb-0", "mb-0"])] as any;
    }

    public onClose(): void {
        if (this.isDialog) this.dialogRef?.close();
        else this.closeClick.emit();
    }
}
